export function linkChecking(context: string) {
  const relChecking = context.replace(
    /(<a[^<>]*?rel="(.*?)[^<>]*?)/g,
    (match) => `${match}nofollow noreferrer noopener `
  );
  return relChecking.replace(
    /(<a(?![^>]*\brel=)[^>]*?)/g,
    '$1 rel="nofollow noreferrer noopener" '
  );
}
